export interface LegalSection {
  heading: string;
  lines: string[];
}

// Entries of the comma-separated `bottom_description` that start a new block
const LEGAL_SECTION_HEADING =
  /^(Verwaltungsratsvorsitzender|Geschäftsführer|Amtsgericht)\b/;

/**
 * Splits the partner `bottom_description` (comma separated) into blocks with
 * a bold heading followed by plain lines, as shown in the Figma footer.
 */
export const parseLegalDescription = (description: string): LegalSection[] =>
  description
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .reduce<LegalSection[]>((sections, part, index) => {
      if (index === 0 || LEGAL_SECTION_HEADING.test(part)) {
        const colonIndex = part.indexOf(':');
        if (colonIndex > -1 && colonIndex < part.length - 1) {
          sections.push({
            heading: part.slice(0, colonIndex + 1),
            lines: [part.slice(colonIndex + 1).trim()],
          });
        } else {
          sections.push({ heading: part, lines: [] });
        }
      } else {
        sections[sections.length - 1].lines.push(part);
      }
      return sections;
    }, []);
